import { __awaiter } from "tslib";
import AjaxUtils from './ajaxUtils';
export const acquireContacts = (contactsData) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield AjaxUtils.post('/v2/acquired', contactsData);
    }
    catch (e) {
        return undefined;
    }
});
